import ChartComponent from "./ChartComponent";
import * as d3 from 'd3';
import React from 'react';

const Histogram = ({ data, showText = true, barColor = 'black', xScale, yScale, height, onMouseOver = () => { }, onMouseOut = () => { } }) => {
    function draw(chart) {
        const bars = chart.selectAll(".Bar").data(data).enter()
            .append("g").attr("class", "Bar");

        //create the rectangles.
        bars.append("rect")
            .attr("x", function (d) { return xScale(d[0]); })
            .attr("y", function (d) { return yScale(d[1]); })
            .attr("width", xScale.bandwidth())
            .attr("height", function (d) { return height - yScale(d[1]); })
            .attr('fill', barColor)
            .on("mouseover", onMouseOver)
            .on("mouseout", onMouseOut);

        if (showText) {
            bars.append("text").text(function (d) { return d3.format(",")(d[1]) })
                .attr("x", function (d) { return xScale(d[0]) + xScale.bandwidth() / 2; })
                .attr("y", function (d) { return yScale(d[1]) - 5; })
                .attr("text-anchor", "middle");
        }
    }

    function update(chart) {
        // update the domain of the y-axis map to reflect change in frequencies.
        yScale.domain([0, d3.max(data, function (d) { return d[1]; })]);

        // Attach the new data to the bars.
        const bars = chart.selectAll(".Bar").data(data);

        // transition the height and color of rectangles.
        bars.select("rect").transition().duration(500)
            .attr("y", function (d) { return yScale(d[1]); })
            .attr("height", function (d) { return height - yScale(d[1]); })
            .attr("fill", barColor);

        // transition the frequency labels location and change value.
        bars.select("text").transition().duration(500)
            .text(function (d) { return d3.format(",")(d[1]) })
            .attr("y", function (d) { return yScale(d[1]) - 5; });
    }

    return (
        <ChartComponent
            draw={draw}
            update={update}
        />
    )
}

export default Histogram
